import React from "react";

export default function content() {
  return (
    <>
      <div className="container mt-4 mb-3" style={{ textAlign: "justify" }}>
        <div className="row">
          <div className="col-md-12">
            <p>
              At Bright Airways, we are committed to not only providing
              world-class travel experiences but also shaping the future of
              aviation through career development. Whether you’re passionate
              about working in the skies as part of our Cabin Crew, on the
              ground as part of our Airport Staff, or behind the scenes in
              management and operations, Bright Airways offers exciting
              opportunities for individuals of all backgrounds. Join our team
              and embark on a journey that promises professional growth,
              continuous learning, and the chance to make a real impact in the
              aviation industry.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
